import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { updateUser_MyProfile_Email } from '../../../../../services/services';

const UpdateUserMyProfileEmail = () => {
  const { token } = useParams();

  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
   fetchUpdateUserMyProfileEmail();

  }, [token]);

  const fetchUpdateUserMyProfileEmail = async () => {
     try {
      setError("");
      setMessage("true");
    
      const res = await updateUser_MyProfile_Email(token);

    }
    catch (err) {
      console.error(err);
      //setError(err);
      setMessage("false");
    }
    finally {
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "24px",
        background: "#f5f5f5",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "500px",
          background: "#fff",
          borderRadius: "8px",
          padding: "24px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {message === "true" && (
          <div style={{textAlign: "center"}}>
            <h2 style={{ color: "#43A047" }}>Email changed!</h2>

            <Link to="/profile" style={{ textDecoration: "none" }}>
              <button className="label-btn" style={{ "--label-btn-color": "#43A047" }}
              >
                Back here
              </button>
            </Link>
          </div>
        )}

        {message === "false" && (
          <div
            style={{
              background: "#fdecea",
              color: "#b71c1c",
              padding: "12px",
              borderRadius: "4px",
              textAlign: "center"
            }}
          >
            <strong>Error:</strong> Link expired!
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateUserMyProfileEmail;
